/**
 * VMP IDs for the pure Sulphadoxine-Pyrimethamine (SP) products dispensed for
 * IPTp (Intermittent Preventive Treatment in pregnancy).
 *
 * Only pure SP qualifies. Combinations with Artesunate (used for malaria
 * treatment) and Amodiaquine (used for seasonal malaria chemoprevention in
 * children) are deliberately excluded — they are not IPTp regimens.
 */
export const IPTP_SP_VMP_IDS: ReadonlySet<string> = new Set([
  // Sulfadoxine 500mg / Pyrimethamine 25mg tablet
  "cbf1fbcb-5a7f-48a6-a859-d5c59b46ce5a",
  // Sulfadoxine 500mg + Pyrimethamine 25mg oral suspension
  "56486d76-bfad-4af2-93c7-f5098a4261dc",
]);

export const isIptpSpVmpId = (vmpId: string | null | undefined): boolean =>
  !!vmpId && IPTP_SP_VMP_IDS.has(vmpId);
